module.exports = __webpack_public_path__ + "static/media/group.70ca56d2.png";